import React from 'react'
import { useDropzone } from 'react-dropzone'
import classNames from 'classnames'

import styles from './FileInput.module.css'

export default function FileInput({ input, meta, label, helpText }) {
  const { value, onChange } = input

  const handleDrop = (acceptedFiles, rejectedFiles) => {
    const files = acceptedFiles.concat(rejectedFiles)
    const file = files[0]

    const reader = new FileReader()

    reader.onload = () => {
      try {
        const result = JSON.parse(reader.result)

        onChange({
          filename: file.name,
          data: result,
        })
      } catch (err) {
        window.alert('The file you uploaded is invalid.')
      }
    }

    reader.onerror = () => {
      window.alert(`Error: ${reader.error.message}`)
    }

    reader.readAsText(acceptedFiles[0])
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
  })

  const { error: errorMessage, touched } = meta
  const hasError = errorMessage && touched

  const { filename } = value || {}

  return (
    <div
      className={classNames(
        styles.wrapper,
        hasError && styles.error,
        filename && styles.hasValue
      )}
    >
      <div className={styles.labelWrapper}>
        <label>{label}</label>
        {helpText && <div className={styles.helpText}>{helpText}</div>}
      </div>
      <div {...getRootProps()} className={styles.innerWrapper}>
        <input {...getInputProps()} />
        <div className={styles.dropTarget}>
          {isDragActive ? (
            <h3>Drop file here...</h3>
          ) : filename ? (
            <h3>{filename}</h3>
          ) : (
            <>
              <h3>Drop JSON file</h3>
              <p>or click here to select</p>
            </>
          )}
        </div>
      </div>
      {hasError && <p className={styles.errorMessage}>{errorMessage}</p>}
    </div>
  )
}
